import {Vue} from 'vue-property-decorator';

export class EventBus {
    private readonly vue: Vue = new Vue();

    public emit(event: string, data: any) {
        this.vue.$emit(event, data);
    }

    public on<T>(event: string, handler: (data: T) => any) {
        this.vue.$on(event, handler);
    }
}

export const EVENT_PARAMETERS_VALIDATED = 'parametersValidated';
export const EVENT_LOCATION_VALIDATED = 'locationValidated';
